import { Common, ApiBind } from './common.model';
import { AdRequestRelation } from './ad-request-relation.model';
import { PlacementRelationOsGroup } from './placement-relation-os-group.model';
import { PlacementRelationSDKVersionGroup } from './placement-relation-sdk-version-group.model';

export class PlacementRelation extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'media_type' })
  mediaType: number;

  @ApiBind({ column: 'ad_format' })
  adFormat: number;

  @ApiBind({ column: 'ad_request_relations', model: (values) => values.map(value => new AdRequestRelation(value)) })
  adRequestRelations: AdRequestRelation[];

  @ApiBind({ column: 'os_groups', model: (values) => values.map(value => new PlacementRelationOsGroup(value)) })
  placementRelationOsGroups: PlacementRelationOsGroup[];

  @ApiBind({ column: 'sdk_version_groups', model: (values) => values.map(value => new PlacementRelationSDKVersionGroup(value)) })
  PlacementRelationSDKVersionGroups: PlacementRelationSDKVersionGroup[];

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  @ApiBind({ column: 'updated_by' })
  updatedBy: string;

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }
}
